import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import Button from "../../../ui/molecules/button"
import Input from "../../../ui/molecules/input"
import { resetSotCreationRequest, resetSotValidationStatus, setSotCreationAddress, setSotCreationCity, setSotCreationCode, setSotCreationEmail, setSotCreationFax, setSotCreationManager, setSotCreationName, setSotCreationPec, setSotCreationPhone, setSotCreationProvince, setSotCreationRegion, setSotCreationZipcode, SOTCreation, SotValidation } from "../slice"
import { OptionType, Province, Region, regioniProvinceMap, regions } from "../../../utils"
import { provinceComuniMap } from "../../../utils/listaComuni"
import { SelectCustom } from "../../../ui/molecules/select"
import { setCountryRegion } from "../../clienti/slice"

export function SOTRight() {
    const dispatch = useAppDispatch()
    const sotState = useAppSelector(state => state.headQuarter)
    const [provinceOptions, setProvinceOptions] = useState<OptionType[]>([]);
    const [selectedRegion, setSelectedRegion] = useState<OptionType | null>(null);
    const [comuneOptions, setComuneOptions] = useState<OptionType[]>([]);
    const [selectedComune, setSelectedComune] = useState<OptionType | null>(null);
    const [selectedProvince, setSelectedProvince] = useState<OptionType | null>(null);

    const regionOptions: OptionType[] = Array.from(regioniProvinceMap.keys()).map(region => ({
        value: region,
        label: region
    }));

    useEffect(() => {
        if (selectedRegion) {
            const foundRegion = regions.find((region: Region) => region.name === selectedRegion.toString());
            if (foundRegion) {
                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));
                setProvinceOptions(newProvinceOptions);
            } else {
                setProvinceOptions([]);
            }
        } else {
            setProvinceOptions([]);
        }
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedProvince) {
            const comuni = provinceComuniMap.get(selectedProvince.toString()) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setComuneOptions(newComuneOptions);
        } else {
            setComuneOptions([]);
        }
    }, [selectedProvince]);

    const handleRegionChange = (selectedOption: OptionType | null) => {
        setSelectedRegion(selectedOption);
        setSelectedProvince(null); // Reset province when region changes
        setSelectedComune(null);
    };

    const handleProvinceChange = (selectedOption: OptionType | null) => {
        setSelectedProvince(selectedOption);
        setSelectedComune(null);
    };

    useEffect(() => {
        if (sotState.sotValidationStatus === 'successfully' && !sotState.onEdit) {
            const req = sotState.sotCreationRequest
            dispatch(resetSotValidationStatus())
            dispatch(SOTCreation({
                manager: req.manager !== '' ? req.manager : undefined,
                pec: req.pec !== '' ? req.pec : undefined,
                phone: req.phone !== '' ? req.phone : undefined,
                province: req.province !== '' ? req.province : undefined,
                city: req.city !== '' ? req.city : undefined,
                code: req.code !== '' ? req.code : undefined,
                region: req.region !== '' ? req.region : undefined,
                zipCode: req.zipCode !== '' ? req.zipCode : undefined,
                address: req.address !== '' ? req.address : undefined,
                fax: req.fax !== '' ? req.fax : undefined,
                name: req.name !== '' ? req.name : undefined,
                email: req.email !== '' ? req.email : undefined
            }))
        }
    }, [sotState.sotValidationStatus])

    useEffect(() => {
        if (sotState.sotCreationStatus === 'successfully') {
            dispatch(resetSotCreationRequest())
        }
    }, [sotState.sotCreationStatus])

    return (
        <div style={{ padding: '0px 24px 24px 24px' }}>
            <div className="text-left pb-3 pt-5">
                <span className="rb-title" >
                    SOT
                </span>
            </div>

            <div className='pb-3'>
                <Input
                    label={'Codice'}
                    placeholder="Specifica codice..."
                    error={sotState.sotErrors.code}
                    supportingText={sotState.sotErrors.code ? 'Codice mancante' : undefined}
                    value={sotState.sotCreationRequest.code}
                    onChangeText={(text) => dispatch(setSotCreationCode(text))}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'Nome'}
                    placeholder="Specifica nome..."
                    value={sotState.sotCreationRequest.name}
                    onChangeText={(text) => dispatch(setSotCreationName(text))}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'Email'}
                    placeholder="Specifica email..."
                    error={sotState.sotErrors.email}
                    supportingText={sotState.sotErrors.email ? 'Email mancante' : undefined}
                    value={sotState.sotCreationRequest.email}
                    onChangeText={(text) => dispatch(setSotCreationEmail(text))}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'PEC'}
                    placeholder="Specifica PEC..."
                    value={sotState.sotCreationRequest.pec}
                    onChangeText={(text) => dispatch(setSotCreationPec(text))}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'Telefono'}
                    placeholder="Specifica telefono..."
                    value={sotState.sotCreationRequest.phone}
                    onChangeText={(text) => dispatch(setSotCreationPhone(text))}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'Fax'}
                    placeholder="Specifica fax..."
                    value={sotState.sotCreationRequest.fax}
                    onChangeText={(text) => dispatch(setSotCreationFax(text))}
                />
            </div>

            <div className='pb-3'>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                    <span className="input-label">Regione</span>
                </div>
                <SelectCustom
                    error={sotState.sotErrors.region}
                    errorLabel={'Regione mancante'}
                    value={sotState.sotCreationRequest.region}
                    placeholder={'Regione'}
                    options={regionOptions}
                    onChange={(value) => { handleRegionChange(value as unknown as OptionType | null); dispatch(setSotCreationRegion(value)) }}
                />
            </div>

            <div className='pb-3'>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                    <span className="input-label">Provincia</span>
                </div>
                <SelectCustom
                    error={sotState.sotErrors.province}
                    errorLabel={'Provincia mancante'}
                    placeholder={'Provincia'}
                    options={provinceOptions}
                    value={sotState.sotCreationRequest.province}
                    onChange={(value) => { handleProvinceChange(value as unknown as OptionType | null); dispatch(setSotCreationProvince(value)) }}
                />
            </div>

            <div className='pb-3'>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                    <span className="input-label">Comune</span>
                </div>
                <SelectCustom
                    error={sotState.sotErrors.city}
                    errorLabel={'Città mancante'}
                    value={sotState.sotCreationRequest.city}
                    placeholder={'Comune'}
                    options={comuneOptions}
                    onChange={(text) => { dispatch(setSotCreationCity(text)) }}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'Indirizzo'}
                    placeholder="Specifica indirizzo..."
                    error={sotState.sotErrors.address}
                    supportingText={sotState.sotErrors.address ? 'Indirizzo mancante' : undefined}
                    value={sotState.sotCreationRequest.address}
                    onChangeText={(text) => dispatch(setSotCreationAddress(text))}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'CAP'}
                    placeholder="Specifica CAP..."
                    value={sotState.sotCreationRequest.zipCode}
                    onChangeText={(text) => dispatch(setSotCreationZipcode(text))}
                />
            </div>

            <div className='pb-3'>
                <Input
                    label={'Manager'}
                    placeholder="Specifica manager..."
                    value={sotState.sotCreationRequest.manager}
                    onChangeText={(text) => dispatch(setSotCreationManager(text))}
                />
            </div>

            <div>
                <Button
                    variant='solid'
                    color='orange'
                    iconPosition='off'
                    size='md'
                    label='Aggiungi SOT'
                    onClick={() => {
                        dispatch(SotValidation(sotState.sotCreationRequest))
                    }}
                />
            </div>
        </div>
    )
}